<!--
    描述：选择系统码表弹框
    时间：2020-05-18
    Created by yefan
-->
<template>
    <div class="h100">
        <div class="w-page-main">
            <div class="w-page-header">
                <search-area ref="searchContent" v-model="searchForm.sname" :showMore="false" placeholderName="字典名称"
                             @on-search="onSearch" @on-refresh="onRefresh" @on-reset="onReset"></search-area>
            </div>
            <div class="w-page-container">
                <div class="w-table-layout w-table-page">
                    <div class="w-table-content" ref="dictsContent">
                        <el-table v-loading="dictsData.loading" :data="dictsData.tableData" :border="true"
                                  :height="dictsData.tableH" ref="softWareTable" highlight-current-row
                                  @row-dblclick="cblClick">
                            <el-table-column type="index" align="center" width="50"></el-table-column>
                            <el-table-column prop="value" align="center" label="字典编码" min-width="120"></el-table-column>
                            <el-table-column prop="sname" align="center" label="字典名称" min-width="120"></el-table-column>
                        </el-table>
                    </div>
                    <div class="w-table-footer text-center">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                       :current-page="dictsData.currentPage" :page-sizes="dictsData.pageList"
                                       :page-size="dictsData.pageSize" layout="total, sizes, prev, pager, next, jumper"
                                       :total="dictsData.total"></el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import {selectPageDicts} from '@/api/modules/dict.js'
    import searchArea from '@/components/searchArea/searchArea'

    export default {
        components: {searchArea},
        data() {
            return {
                dictsData: {
                    loading: false,
                    tableH: 400,
                    tableData: [],
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                    pageList: [10, 20, 50, 100] // 显示条数数组
                },
                searchForm: {
                    sname: ''
                }
            }
        },
        methods: {
            getDicts() {
                let param = {}
                param.sname = this.searchForm.sname;
                param.current = this.dictsData.currentPage;
                param.size = this.dictsData.pageSize;
                selectPageDicts(param).then(res => {
                    this.dictsData.tableData = res.data.records;
                    this.dictsData.total = parseInt(res.data.total)
                })
            },

            //双击列表行事件
            cblClick(row) {
                this.$emit('on-selected', row)
            },

            // 切换显示条数
            handleSizeChange(val) {
                this.dictsData.pageSize = val
                this.getDicts()
            },

            // 切换当前页码
            handleCurrentChange(cur) {
                this.dictsData.currentPage = cur
                this.getDicts()
            },

            // 确认搜索
            onSearch() {
                this.getDicts()
            },

            // 点击刷新
            onRefresh() {
                this.onReset();
                this.onSearch()
            },

            // 点击重置
            onReset() {
                this.searchForm.sname = ''
            }
        },

        created() {
            this.getDicts()
        },

        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.dictsData.tableH = this.$refs.dictsContent.offsetHeight
                }, 100)
            })
        },

        computed: {
            ...mapState('app', {clientSize: state => state.clientSize})
        },

        watch: {
            clientSize(val) {
                this.dictsData.tableH = this.$refs.dictsContent.offsetHeight
            }
        }
    }
</script>
<style lang="less"></style>
